import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import InfoIconOutlined from '@cp/src/assets/images/icons/InfoIconOutlined';
import { FEEDBACK_TYPES_OPTIONS } from '@cp/src/pages/Cases/constants/CasesConstants';

interface DetailsPopperTriggerProps {
  callDisplayData?: {
    callType?: string;
    status?: string;
  };
}

const DetailsPopperTrigger = (props: DetailsPopperTriggerProps) => {
  const { callDisplayData } = props;
  return (
    <div className="flex flex-row justify-between px-3 pt-2 pb-3 bg-[var(--bg-primary-warm)] cursor-pointer">
      <div className="flex flex-col">
        <Typography variant="p4" color="var(--grayscale-3)">
          Call Type
        </Typography>
        <Typography variant="p4" color="var(--grayscale-1)">
          {callDisplayData?.callType || '-'}
        </Typography>
      </div>

      <div className="flex flex-col">
        <div>
          <Typography variant="p4" color="var(--grayscale-3)">
            Status
          </Typography>
          <Typography variant="p4" color="var(--grayscale-1)">
            {FEEDBACK_TYPES_OPTIONS.find(option => option.value === callDisplayData?.status)
              ?.label ||
              callDisplayData?.status ||
              '-'}
          </Typography>
        </div>
        <div>
          <Typography variant="p5" color="var(--grayscale-3)">
            Customer
          </Typography>
        </div>
      </div>
      <InfoIconOutlined fillColor="var(--grayscale-1)" />
    </div>
  );
};

export default DetailsPopperTrigger;
